(() => {
  if (window.__JoffzListingPreviewControllerV4) return;
  window.__JoffzListingPreviewControllerV4 = true;

  const FRAME_KEY = 'joffz:listing-frame';
  const MOUNT_KEY = 'joffz:listing-mount';
  const FRAMES = new Set(['print-only', 'black', 'white', 'oak']);
  const MOUNTS = new Set(['no', 'yes']);

  const safeGet = (key) => {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  };

  const safeSet = (key, value) => {
    try { window.localStorage.setItem(key, value); } catch (_) {}
  };

  const state = {
    frame: FRAMES.has(safeGet(FRAME_KEY)) ? safeGet(FRAME_KEY) : 'print-only',
    mount: MOUNTS.has(safeGet(MOUNT_KEY)) ? safeGet(MOUNT_KEY) : 'no'
  };

  function applyState() {
    if (state.frame === 'print-only') state.mount = 'no';

    document.documentElement.dataset.jpcListingFrame = state.frame;
    document.documentElement.dataset.jpcListingMount = state.mount;
    safeSet(FRAME_KEY, state.frame);
    safeSet(MOUNT_KEY, state.mount);

    document.querySelectorAll('[data-jpc-listing-toolbar]').forEach((toolbar) => {
      toolbar.querySelectorAll('[data-jpc-frame]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.jpcFrame === state.frame));
      });

      toolbar.querySelectorAll('[data-jpc-mount]').forEach((button) => {
        const isMountYes = button.dataset.jpcMount === 'yes';
        button.disabled = state.frame === 'print-only' && isMountYes;
        button.setAttribute('aria-pressed', String(button.dataset.jpcMount === state.mount));
      });
    });
  }

  function placeSearchToolbar() {
    const searchGrid = document.querySelector('.template-search #ProductGridContainer');
    if (!searchGrid) return;

    document.querySelectorAll('[data-jpc-listing-toolbar-shell]').forEach((shell) => {
      if (shell.dataset.jpcPlaced === 'true') return;
      searchGrid.parentNode.insertBefore(shell, searchGrid);
      shell.dataset.jpcPlaced = 'true';
    });
  }

  document.addEventListener('click', (event) => {
    const frameButton = event.target.closest('[data-jpc-frame]');
    if (frameButton && FRAMES.has(frameButton.dataset.jpcFrame)) {
      state.frame = frameButton.dataset.jpcFrame;
      if (state.frame === 'print-only') state.mount = 'no';
      applyState();
      return;
    }

    const mountButton = event.target.closest('[data-jpc-mount]');
    if (mountButton && !mountButton.disabled && MOUNTS.has(mountButton.dataset.jpcMount)) {
      state.mount = mountButton.dataset.jpcMount;
      applyState();
    }
  });

  function init() {
    placeSearchToolbar();
    applyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    placeSearchToolbar();
    applyState();
  });
})();
